(() => {
  const $ = (s, root=document) => root.querySelector(s);
  const $$ = (s, root=document) => [...root.querySelectorAll(s)];

  const drawer = $('[data-cart-drawer]');
  const openDrawer = async () => {
    if (!drawer) return;
    await refreshCart();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
  };
  $$('[data-cart-open]').forEach(b=>b.addEventListener('click', e=>{e.preventDefault();openDrawer()}));
  $$('[data-cart-close]').forEach(b=>b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown',e=>{if(e.key==='Escape') closeDrawer()});

  async function refreshCart(){
    if(!drawer) return;
    const cart = await fetch('/cart.js').then(r=>r.json());
    const list = $('[data-cart-items]', drawer);
    const countNodes = $$('[data-cart-count]');
    countNodes.forEach(n=>n.textContent=cart.item_count);
    if (!list) return;
    if (!cart.items.length) {
      list.innerHTML = '<p style="padding:24px 0">Your cart is empty.</p>';
    } else {
      list.innerHTML = cart.items.map(item => `
        <div class="drawer-item">
          ${item.image ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}">` : ''}
          <div>
            <div class="drawer-item__title">${escapeHtml(item.product_title)}</div>
            <div class="drawer-item__meta">${escapeHtml(item.variant_title || '')}</div>
            <div class="drawer-item__meta">Qty ${item.quantity} · ${formatMoney(item.final_line_price)}</div>
          </div>
        </div>`).join('');
    }
    const total = $('[data-cart-total]', drawer); if(total) total.textContent=formatMoney(cart.total_price);
    const threshold = parseInt(drawer.dataset.freeShipping || '0',10);
    const fill = $('[data-progress-fill]', drawer); const text=$('[data-progress-text]', drawer);
    if(fill && text && threshold>0){
      const pct=Math.min(100,(cart.total_price/threshold)*100); fill.style.width=pct+'%';
      text.textContent = cart.total_price >= threshold ? 'Free shipping unlocked' : `${formatMoney(threshold-cart.total_price)} away from free shipping`;
    }
  }

  function formatMoney(cents){
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:window.Shopify?.currency?.active || 'USD'}).format(cents/100); }
    catch(e){ return (cents/100).toFixed(2); }
  }
  function escapeHtml(s=''){ return String(s).replace(/[&<>'"]/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[m])); }

  $$('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async e => {
      if(!form.hasAttribute('data-ajax-cart')) return;
      e.preventDefault();
      const btn=$('[type="submit"]',form); const old=btn?.textContent;
      if(btn){btn.disabled=true;btn.textContent='Adding…'}
      const fd=new FormData(form);
      const res=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:fd});
      if(btn){btn.disabled=false;btn.textContent=old}
      if(res.ok) openDrawer(); else alert('Could not add this item to cart.');
    });
  });

  const mainAtc=$('[data-main-atc]'); const sticky=$('[data-sticky-atc]');
  if(mainAtc && sticky){
    const io=new IntersectionObserver(([entry])=>sticky.classList.toggle('is-visible',!entry.isIntersecting),{threshold:.1});
    io.observe(mainAtc);
  }

  $$('[data-sticky-submit]').forEach(b=>b.addEventListener('click',()=>mainAtc?.click()));

  $$('[data-mobile-toggle]').forEach(btn=>btn.addEventListener('click',()=>{
    const menu=$('[data-mobile-menu]'); if(!menu)return; const open=menu.hidden; menu.hidden=!open; btn.setAttribute('aria-expanded',String(open));
  }));
})();
